import { useMsal, useIsAuthenticated, AuthenticatedTemplate, MsalProvider } from "@azure/msal-react";
import { InteractionStatus, InteractionRequiredAuthError } from "@azure/msal-browser";
import React, { useEffect, useState } from 'react';
import { graphRequest, loginRequest } from '../security/authConfig';
import msalInstance from "../security/msalInstance";
import SessionStorageService from "../services/SessionStorageService";

const ProfileContent = () => {
  const { accounts } = useMsal();
  return (
    <>
      Welcome {accounts[0].name}
    </>
  );
};

export default function UserComponent({ callback }) {
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  // const [token, setToken] = useState(null);
  useEffect(() => {
    const login = async() => {
      if (!isAuthenticated && inProgress === InteractionStatus.None && !SessionStorageService.getUserId()) {
        console.log("Initiating login redirect...");
        sessionStorage.setItem("loginAttempted", "true");
        await instance.loginRedirect(loginRequest);
        console.log("Login redirect completed.");
      }
    }
    login();
  }, [instance, inProgress, isAuthenticated]);

  useEffect(() => {
    async function getToken() {
      if (isAuthenticated && accounts.length > 0 && inProgress === InteractionStatus.None) {
        try {
          const response = await instance.acquireTokenSilent({
            loginRequest,
            account: accounts[0],
          });
          // console.log("scopes:", response.scopes, "Access Token:", response.accessToken);
       //   SessionStorageService.setUserId(response.account.localAccountId); // Persist user ID
          if (process.env.IS_RUNTIME === 'false') {
            const apiResponse = await instance.acquireTokenSilent({...graphRequest, account: accounts[0]});
            console.log("api scope", apiResponse.scopes, "API Token:", apiResponse.accessToken);
          }
        } catch (error) {
          console.error("Token Fetch Failed:", error);
          if (error.name === "BrowserAuthError" && inProgress === InteractionStatus.None) {
            instance.loginRedirect(loginRequest);
          }
        }
      }
    }
    if (process.env.IS_RUNTIME === 'false' || !SessionStorageService.getUserId()) {
      getToken();
    }
    callback();
  }, [instance, inProgress, isAuthenticated, accounts]);
  
  
  // ✅ Token refresh logic
  useEffect(() => {
    const interval = setInterval(() => {
      if (process.env.IS_RUNTIME === 'false') {
        const activeAccount = instance.getActiveAccount(); // ✅ Ensure active account is set
    
        if (!activeAccount) {
          console.error("No active account set.");
          return;
        }
    
        instance.acquireTokenSilent({ 
          scopes: ["User.Read"], 
          account: activeAccount 
        })
        .then(response => {
          // console.log("Access Token:", response.accessToken);
        })
        .catch(error => {
          console.error("Token refresh failed:", error);
    
          if (error.message.includes("interaction_required")) {
            instance.loginPopup({
              scopes: ["User.Read"],
            })
            .then(response => {
              instance.setActiveAccount(response.account); // ✅ Ensure active account is set
            })
            .catch(loginError => console.error("Login failed:", loginError));
          }
        });
      } else {
        instance.acquireTokenSilent({ loginRequest, account: accounts[0] })
        .then(response => {
          // console.log("Access Token:", response.accessToken);
        })
        .catch(error => {
          console.error("Token refresh failed:", error);
  
          // Check for interaction required errors
          if (error instanceof InteractionRequiredAuthError || error.errorCode === "interaction_required") {
            instance.loginPopup(loginRequest)
              .then(response => {
                // console.log("Reauthenticated, new token:", response.accessToken);
              })
              .catch(loginError => console.error("Login failed:", loginError));
          }
        });
      }
    }, 10 * 60 * 1000); // Refresh every 10 minutes
  
    return () => clearInterval(interval);
  }, [instance, accounts]);
  
  
  return (
    <div>
      <AuthenticatedTemplate>
        <ProfileContent />
      </ AuthenticatedTemplate>
    </div>
  );
}


export const getAzureUserInfo = () => {
  try {
    const account = msalInstance.getAllAccounts()[0];
    if (account) {
      return account;
    }
  } catch (error) {
    console.error("Error getting user info from azure:", error);
  }
  return null;
}
